export default __webpack_public_path__ + "static/media/gmail.e1bc2ceb.svg";